export enum AdminTypeEnum {
  SCAN_CENTER_ADMIN = "scan_center_admin",
  TELERAD_ADMIN = "telerad_admin",
  DIGITAL_SHARING_ADMIN = "digital_sharing_admin"
}
